import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import type { CSSProperties } from "react";
import { useState } from "react";

interface EditableCellProps {
    value: any;
    rowId: string | number;
    columnId: string;
    onSave?: (rowId: string | number, columnId: string, value: any) => void;
    highlighted?: boolean;
    align?: "left" | "center" | "right";
    width?: string;
    style?: CSSProperties;
}

// Column type configuration
const COLUMN_CONFIG: Record<string, { type: "number" | "text"; convert: (value: string) => any }> = {
    consumptionCount: {
        type: "number",
        convert: (value) => (value === "" ? 0 : Number(value)),
    },
    avgConsumptionDuration: {
        type: "number",
        convert: (value) => (value === "" ? 0 : Number(value)),
    },
    coefficient: {
        type: "number",
        convert: (value) => (value === "" ? 1 : Number(value)),
    },
};

const EditableCell = ({
    value,
    rowId,
    columnId,
    onSave,
    highlighted,
    align = "left",
    width,
    style,
}: EditableCellProps) => {
    const [editValue, setEditValue] = useState(value);
    const columnConfig = COLUMN_CONFIG[columnId] || { type: "text", convert: (v: string) => v };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setEditValue(newValue);
        if (onSave) {
            const convertedValue = columnConfig.convert(newValue);
            onSave(rowId, columnId, convertedValue);
        }
    };

    return (
        <td
            style={{
                padding: "12px 8px",
                borderBottom: "1px solid #eaeaea",
                backgroundColor: highlighted ? "#FFF9E6" : "transparent",
                textAlign: align,
                fontSize: "13px",
                color: "#2D2D2D",
                width: width,
                cursor: "pointer",
                verticalAlign: "middle",
                ...style,
            }}
        >
            <StyledTextField
                value={editValue}
                onChange={handleChange}
                size="small"
                fullWidth
                type={columnConfig.type}
                inputProps={{
                    style: {
                        fontSize: "13px",
                        textAlign: align,
                        backgroundColor: "#F5F5F5",
                        padding: "4px 8px",
                    },
                }}
            />
        </td>
    );
};

export default EditableCell;
